export enum LegalArea {
  DE = 'DE',
  EU = 'EU',
  OTHER = 'other',
}
